<template>
  <v-dialog v-model="dialog" persistent max-width="450">
    <v-card>
      <v-toolbar color="primary" dense dark>
        <v-toolbar-title>Versão do Sistema</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container>
        <v-row>
          <v-col>
            <v-sheet class="version">
              <v-icon color="primary">extension</v-icon>
              <span>{{ versionBack }}</span>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import store from '@/store';
import { sleep } from '@/helpers/page';

export default {
  props: {
    dialog: { type: Boolean, default: false }
  },

  beforeCreate() {
    store.dispatch('version/getVersionBack');
  },

  computed: {
    versionBack() {
      return store.getters['version/getVersionBack'];
    }
  },

  methods: {
    async close() {
      await sleep(100);
      this.$emit('handleVersion');
    }
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  overflow: hidden;
}

.version {
  text-align: center;
  padding: 1rem 0;
  span {
    font-size: 1rem;
  }
  h2 {
    margin: 0.8rem 0;
  }
  .v-icon {
    font-size: 4rem;
    display: block;
    margin-bottom: 10px;
  }
}
</style>
